<template>
  <div>
    <BaseDialog :value="displayShareModal" :persistent="true">
      <TheShareModal></TheShareModal>
    </BaseDialog>
  </div>
</template>

<script>
// Libraries
import { mapState } from "vuex";

// Components
import TheShareModal from "../../share/components/TheShareModal";

export default {
  name: "AppModals",
  components: {
    TheShareModal
  },
  // DATAs
  computed: {
    ...mapState({
      displayShareModal: state => state.share.displayShareModal,
      isShareModalPersistent: state => state.share.isShareModalPersistent
    })
  }
};
</script>

<style lang="scss" scoped>
</style>
